import React from 'react';
import { InfoProvider } from "./context/InfoContext";
import {useRoutes, useRedirect, A, navigate} from 'hookrouter';

//Routes
import Routes from "./router/Routes";

//CSS
import './App.css';


function App() {
  const routeResult = useRoutes(Routes);
  
  // {!isLoggedIn() ? publicRoutesApp : privateRoutesApp}

  return (
    <div className="wrapper">
      <InfoProvider>
        {routeResult}
      </InfoProvider>
    </div>
  );
}

export default App;
